// extracted by mini-css-extract-plugin
export default {"main_wrapper":"Goaldashbord_main_wrapper__vd-nY","sideBarToogle":"Goaldashbord_sideBarToogle__UWL91"};